import { CONTACT } from "@/config/site";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const FloatingWhatsApp = () => (
  <a
    href={CONTACT.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="WhatsApp करें"
    data-testid="floating-whatsapp-btn"
    className="fixed bottom-[104px] right-[21px] sm:right-[29px] z-40 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_12px_30px_-6px_rgba(37,211,102,0.6)] transition-transform duration-300 hover:scale-110"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
    <WhatsAppIcon className="relative h-7 w-7" />
  </a>
);
